import { render, staticRenderFns } from "./DeveloperList.vue?vue&type=template&id=df1ecd02&scoped=true"
import script from "./DeveloperList.vue?vue&type=script&lang=js"
export * from "./DeveloperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1ecd02",
  null
  
)

export default component.exports